export default "__VITE_ASSET__Dj45B_lz__"